import { cva } from 'class-variance-authority';

export const typographyVariant = cva('', {
  variants: {
    variant: {
      h1: 'text-5xl font-medium leading-tight tracking-tight',
      h2: 'text-3xl font-medium leading-tight tracking-tight',
      h3: 'text-2xl font-medium leading-tight tracking-tight',
      h4: 'text-xl font-medium leading-tight tracking-tight',
      h5: 'text-lg font-medium leading-tight tracking-tight',
      p: 'text-base font-normal leading-normal tracking-normal',
      pBold: 'text-base font-medium leading-normal tracking-normal',
      p2: 'text-sm font-normal leading-normal tracking-normal',
      p2Bold: 'text-sm font-medium leading-normal tracking-normal',
      p2SemiBold: 'text-sm font-semibold leading-normal tracking-normal',
      caption: 'text-xs font-normal leading-snug tracking-normal',
      captionBold: 'text-xs font-medium leading-snug tracking-normal',
      footnote: 'text-[10px] font-normal leading-snug tracking-normal',
      footnoteBold: 'text-[10px] font-medium leading-snug tracking-normal',
    },
  },
  defaultVariants: {
    variant: 'p',
  },
});
